import { SECTION_FAMILY } from 'constants/uTagConstants/ga4';

export const translations = {
    NEW_USER_REQUIREMENTS_VIEW_TITLE: 'newUserRequirements-title',
};

export const TAGGING = {
    REQUIREMENTS_TO_BE_CLIENT: 'requierementsToBeClient',
    BANKING: SECTION_FAMILY,
    ONBOARDING: 'onboarding',
    USER_ONBOARDING: 'userOnboarding',
    PAGE: 'page',
    CLICK: 'click',
    LINK: 'link',
    BODY: 'body',
    MORE_DETAILS: 'moreDetails',
    CLICK_LINK: 'clickLink',
    MORE_DETAILS_LINK: 'moreDetailsLink',
    BUTTON: 'button',
    START: 'start',
    CLICK_BUTTON: 'clickButton',
    START_BUTTON: 'startButton',
    RECOVER_PROCESS: 'recoverProcess',
    RECOVER_PROCESS_BUTTON: 'recoverProcessButton',
    OPEN: 'open',
    MODAL: 'modal',
    COMPONENT: 'modal/processAlreadyStarted',
    FULL: 'full',
    PROCESS_ALREADY_STARTED: 'processAlreadyStarted',
    CROSS: 'cross',
    CLOSE: 'close',
};
